import React from 'react';
import Edit from 'material-ui-icons/Edit';
import Check from 'material-ui-icons/Check';
import Undo from 'material-ui-icons/Undo';
import { withStyles } from 'material-ui/styles';

const styles = {
  actionIcon: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'space-around',
    fontSize: 1.2 + 'rem'
  }
};

function EditParticipantButton(props) {
  const { classes } = props;

  return (
    <div className={classes.actionIcon}>
      {props.isEditing ? (
        <div>
          <Check color="primary" onClick={props.isBeingSaved} />
          <Undo color="secondary" onClick={props.onCancelEditEmail} />
        </div>
      ) : (
        <Edit color="primary" onClick={props.handleIsEditing} />
      )}
    </div>
  );
}

export default withStyles(styles)(EditParticipantButton);



// WEBPACK FOOTER //
// ./src/components/EditParticipantButton.js